import { Route, Router, Redirect } from "@reach/router";
import React from "react";
import "./index.css";
import Dashboard from "./pages/Dashboard";
import Template from "./template";
import AuthPension from "./pages/Login/authPension";
import Rubros from "./pages/Pensiones/rubros";
import Pensiones from "./pages/Pensiones";
import Cart from "./pages/Cart";
import Return from "./pages/Return";
import Inscripciones from "./pages/Inscripciones";
import CartIns from "./pages/CartIns";
import ReturnIns from "./pages/ReturnIns";
import AuthIns from "./pages/Login/authIns";
import AuthMain from "./pages/Login/authMain";
import TemplateIns from "./templateIns";
import Matricula from "./Matricula";
import AuthMatNew from "./pages/Matriculacion/MatLogin/authMatNew";
import AuthMatOld from "./pages/Matriculacion/MatLogin/authMatOld";
import MatriculaList from "./pages/Matriculacion/MatriculaList";
import MatLogin from "./pages/Matriculacion/MatLogin";
import MatriculaSearch from "./pages/Matriculacion/MatriculaSearch";
import MatriculaCart from "./pages/Matriculacion/CartMat";
import MatriculaReturn from "./pages/Matriculacion/MatriculaReturn";
import MatriculaLink from "./pages/Matriculacion/LinkMat"
import LinkMat from "./pages/Link";
import MatMenu from "./pages/Matriculacion/MatMenu";
import RegistroNuevo from "./pages/RegistroNuevo";
import MenuMain from "./pages/MenuMain";
import PrivateRoute from "./privateRoute";
import RecuperaMenu from "./pages/Login/RecuperaMenu";
import RecuperacionClaveEst from "./pages/Login/recuperacionClaveEst";
import RecuperacionClaveNue from "./pages/Login/recuperacionClaveNue";
import ContactoInscripcion from "./pages/Inscripciones/contacto";

// test
import test from "./components/probando";

//-------------------------------------------------------------------------
//Enrutador de la aplicacion de React
//-------------------------------------------------------------------------

const Ruteador = () => {
  return (
        <Router>
          <AuthMain path="/" />
          <AuthMain path="authMain"/>
           <PrivateRoute path="/">
            <MenuMain path="menuMain"/> 
            <MatMenu path="matMenu"/>
          </PrivateRoute>
          <RegistroNuevo path="registroAnai"/>
          <MatLogin path="loginMatricula"/>
          <RecuperacionClaveEst path="recuperarClaveEst"/>
          <RecuperacionClaveNue path="recuperarClaveNue"/>
          <RecuperaMenu path="recuperaMenu"/>
          <Template path="/pension"  >
            <Dashboard path="pagos" />
            <Pensiones path="list"  />
            <Rubros path="rubros/:codEst" />
            <Cart path="cart" />
            <Return path="return/:reference"/>
            
            <Redirect from="aboutus" to="about-us" uri/>
          </Template>

          <Matricula path="/matricula">
            <MatriculaList path="list"/>
            <MatriculaSearch path="search/:codEst" />
            <MatriculaCart path="cartMat" />
            <MatriculaReturn path="return/:reference" />
            <MatriculaLink path="linkMat" />
          </Matricula>

          <LinkMat path="/linkmat">
            
          </LinkMat>

          <AuthMatNew path="authNew" />
          <AuthMatOld path="authAnai" />
          <AuthPension path="authPension" />
          <AuthIns path="authIns"/>

          <TemplateIns path="/inscripcion">
            <Inscripciones path="list" />
            <CartIns path="cartIns"/>
            <ReturnIns path="return/:reference"/>
            <ContactoInscripcion  path="contacto" />
          </TemplateIns>
        </Router>
  )
}

export default Ruteador;